import { Dispatch } from 'react';
import { connect } from 'react-redux';
import { IReduxRootState } from '../../../app/reduxRootState.interface';
import { AddressesActions } from '../addressesActions';
import { AddressesAction } from '../addressesActionType';
import Address from './Address';
import { IAddress } from './address.interface';
import { CardFormatterService } from '../../paymentMethods/cards/card/cardFormatter.service';

const mapStateToProps = (state: IReduxRootState, { address }: { address: IAddress }) => {
    const countries = state.countries.countriesMap;
    const cardRestrictionEnabled = state.app.appConfig.CARD_RESTRICTION_ENABLED ?? true;
    const cards = cardRestrictionEnabled
        ? []
        : Object.values(state.cards.cardsMap || {})
              .filter((card) => card.addressUuid === address.addressUuid && card.cardToken)
              .map((card) =>
                  CardFormatterService.addSpaces(`************${card.numberLast}`, [4, 4, 4, 4]),
              );

    return {
        cards,
        addressTemplate: state.app.clientConfig.presentationConfig['address.template'],
        countries,
        challengerPid: state.app.appConfig.CHALLENGER_PIDS.ADDRESS_DEFAULT ?? '',
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AddressesAction>) => {
    return {
        deleteAddress: (addressUuid: string) => {
            dispatch(AddressesActions.deleteAddress(addressUuid));
        },
        setDefaultShipping: (address: IAddress, isShipping: boolean) => {
            dispatch(AddressesActions.setDefaultShipping(address, isShipping));
        },
    };
};

const AddressContainer = connect(mapStateToProps, mapDispatchToProps)(Address);

export default AddressContainer;
